/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {VelocityTransitionGroup} from 'velocity-react';

import _at from 'lodash/at';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _union from 'lodash/union';
import _pick from 'lodash/pick';

import Translate from '../../Translate';
import DivLoader from '../../DivLoader';

import {FetchAssetById} from '../../../actions/asset/action-asset';
import {InitiatePurchase, StripeProcess, AcknowledgePurchase, ClearPayment} from '../../../actions/purchase/actions-purchase';

class OffersMessage extends Component {
  constructor(props) {
    super(props);

    this.animationEnter = {
      translateY: '0px',
      opacity: 1
    };
    this.animationLeave = {
      translateY: '100px',
      opacity: 0
    };

    this.animationSingleEnter = {
      translateX: '0px'
    };
    this.animationSingleLeave = {
      translateX: '-100px'
    };


    this.animationBundleEnter = {
      translateX: '0px'
    };
    this.animationBundleLeave = {
      translateX: '100px'
    };

    this.state = {
      isShown: false,
      toClose: false,
      asset: {},
      offers: []
    };
  }

  componentDidMount() {

    this.props.FetchAssetById(this.props.message.asset_id);

    this.setState({
      isShown: this.props.isShown
    });
  }

  componentWillReceiveProps(newProps) {
    let state = {};

    state.isShown = newProps.isShown;

    if (_get(newProps, 'asset.id') && newProps.isShown) {
      this._fetchAssetsOfferData(newProps.asset);
    } else if (_get(newProps, 'message.offers')) {

      this._fetchAssetsOfferData({
        id: _get(newProps, 'message.asset_id'),
        offers: _get(newProps, 'message.offers')
      });
    }

    this.setState(state);

    if (_get(newProps, 'payment.state') === 'init' && _get(newProps, 'payment.tx')) {

      if (_get(newProps, 'payment.tx.ack_request.type') === 'stripe') {

        this.props.StripeProcess(_get(newProps, 'asset.id') || _get(this.props, 'message.asset_id'), _get(newProps, 'payment.tx'));
      } else {

        console.warn('init purchase unknown type: ', _get(newProps, 'payment.tx'));
      }
    } else if (_get(newProps, 'payment.state') === 'token' && _get(newProps, 'payment.token')) {

      this.props.AcknowledgePurchase(_get(newProps, 'asset.id') || _get(this.props, 'message.asset_id'), _get(newProps, 'payment.tx.tx_id'), _get(newProps, 'payment.token.id'));

    } else if (_get(newProps, 'payment.state') === 'ack' && _get(newProps, 'payment.purchase')) {

      this.onCrossClick();
      this.props.ClearPayment(_get(newProps, 'asset.id') || _get(this.props, 'message.asset_id'));
    }
  }

  _fetchAssetsOfferData(asset) {
    let state = {};

    state.offers = asset.offers;

    state.offers.forEach((offer) => {
      if (offer.is_from_package) {
        asset.package_id.forEach((package_id) => {
          let pckg = _find(this.props.packages, {id: package_id});

          if (pckg) {
            offer.package = _pick(pckg, ['title', 'resources', 'id']);

            lh.models.asset.methods
              .getPosterUrl(pckg, {
                crop: {x: 132, y: 132},
                cache: false
              })
              .then((url) => {
                offer.picture = url;
              }, (reason) => {

                console.log(reason);
              });
          }
        });
      }
    });

    state.asset = asset;

    this.setState(state);
  }

  onAnimationComplete() {

    if (this.state.toClose) this.props.onClose();
  }

  onAction(action) {

    if (action) action();

    this.onCrossClick();
  }

  onCrossClick() {

    this.setState({
      isShown: false,
      toClose: true
    });
  }

  onOfferClick(assetId, offerId, type) {

    this.props.InitiatePurchase(assetId, offerId, this.props.asset.id || _get(this.props, 'message.asset_id'));
  }

  isSingleOfferAvailable() {

    return this.state.offers && this.state.offers.length && !!this.state.offers
        .filter((offer) => {
          return !offer.is_from_package;
        }).length;
  }

  isBundleAvailable() {

    return this.state.offers && this.state.offers.length && !!this.state.offers
        .filter((offer) => {
          return offer.is_from_package;
        }).length;
  }

  isShowLoader() {

    return _get(this.props.payment, 'initInProgress', null) || _get(this.props.payment, 'tokenInProgress', null) || _get(this.props.payment, 'ackInProgress', null);
  }

  _renderSingleOffer() {

    return this.state.offers
      .filter((offer) => {
        return !offer.is_from_package;
      })
      .map((offer) => {
        let price = '';

        if (offer.type === 'transactional') {
          if (_get(offer, 'right_params.duration') === 0) {
            offer._typeParsed = 'transactional-own';
          } else {
            offer._typeParsed = 'transactional-rent';
          }
        } else {
          offer._typeParsed = offer.type;
        }

        if (_get(offer, 'type') === 'transactional') {
          price = (
            <span className="price">
              <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
              <span>
                {_get(offer, 'billing_params.price') / 100}
                {(_get(offer, 'type') === 'subscription') ?
                  ('/ ' + (_get(offer, 'right_params.duration') > 1 ? _get(offer, 'right_params.duration') + ' ' : '') + _get(offer, 'right_params.duration_unit')) :
                  ''}
              </span>
            </span>
          );

          return (<a key={'offer_' + offer.id} href="javascript:void(0)" className="buy-now pointer" id={'offer_' + offer.id} onClick={this.onOfferClick.bind(this, _get(this.props.asset, 'id'), _get(offer, 'id'))}>
            <span className="offer-text-top">{price}</span>
            <span className="offer-text-bottom"><Translate content={`profile.offers.type.${_get(offer, '_typeParsed', '_')}`} /></span>
          </a>);
        }

        if (_get(offer, 'type') === 'subscription') {

          price = (
            <span className="price">
              <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
              <span>
                {_get(offer, 'billing_params.price') / 100}
                {(_get(offer, 'type') === 'subscription') ?
                  ('/ ' + (_get(offer, 'right_params.duration') > 1 ? _get(offer, 'right_params.duration') + ' ' : '') + _get(offer, 'right_params.duration_unit') + '(s)')
                  :
                  ''}
              </span>
            </span>
          );

          let trialDiv = '';
          if (_get(offer, 'right_params.trial_duration') && _get(offer, 'right_params.trial_duration_unit')) {
            trialDiv = (
              <div className="subscription-fee-more">
                {_get(offer, 'right_params.trial_duration') } {_get(offer, 'right_params.trial_duration_unit')}(s) - <Translate content="profile.offers.free_trial" />. <br />
                <Translate content="profile.offers.free_trial_description" />
              </div>
            );
          }

          return (
            <a key={'offer_' + offer.id} href="javascript:void(0)" className="buy-now pointer" id={'offer_' + offer.id} onClick={this.onOfferClick.bind(this, _get(this.props.asset, 'id'), _get(offer, 'id'))}>
              <span className="offer-text-top subscription">
                {price}
              </span>
              <span className="offer-text-bottom"><Translate content={`profile.offers.type.${_get(offer, '_typeParsed', '_')}`} /></span>
              {trialDiv}
            </a>
          );
        }
      });
  }

  _renderBundleOffer() {

    return this.state.offers
      .filter((offer) => {
        return offer.is_from_package;
      })
      .map((offer) => {
        let price = '';

        if (offer.type === 'transactional') {
          if (_get(offer, 'right_params.duration') === 0) {
            offer._typeParsed = 'transactional-own';
          } else {
            offer._typeParsed = 'transactional-rent';
          }
        } else {
          offer._typeParsed = offer.type;
        }

        if (_get(offer, 'type') === 'transactional') {
          price = (
            <span className="price">
              <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
              <span>
                {_get(offer, 'billing_params.price') / 100}
                {(_get(offer, 'type') === 'subscription') ?
                  ('/ ' + (_get(offer, 'right_params.duration') > 1 ? _get(offer, 'right_params.duration') + ' ' : '') + _get(offer, 'right_params.duration_unit')) :
                  ''}
              </span>
            </span>
          );

          return (<a key={'offer_' + offer.id} href="javascript:void(0)" className="select-package pointer" id={'offer_' + offer.id} onClick={this.onOfferClick.bind(this, _get(offer, 'package.id'), _get(offer, 'id'))}>
            {!!offer.picture && <img className="radius" src={offer.picture} />}
            <span className="offer-text-top">{_get(offer, 'package.title')}</span>
            <span className="offer-text-bottom">
              <strong>{price}</strong>
              <Translate content={`profile.offers.type.${_get(offer, '_typeParsed', '_')}`} />
            </span>
          </a>);
        }

        if (_get(offer, 'type') === 'subscription') {

          price = (
            <span className="price">
              <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
              <span>
                {_get(offer, 'billing_params.price') / 100}
                {(_get(offer, 'type') === 'subscription') ?
                  ('/ ' + (_get(offer, 'right_params.duration') > 1 ? _get(offer, 'right_params.duration') + ' ' : '') + _get(offer, 'right_params.duration_unit') + '(s)')
                  :
                  ''}
              </span>
            </span>
          );

          let trialDiv = '';
          if (_get(offer, 'right_params.trial_duration') && _get(offer, 'right_params.trial_duration_unit')) {
            trialDiv = (
              <div className="subscription-fee-more">
                {_get(offer, 'right_params.trial_duration') } {_get(offer, 'right_params.trial_duration_unit')}(s) - <Translate content="profile.offers.free_trial" />. <br />
                <Translate content="profile.offers.free_trial_description" />
              </div>
            );
          }

          return (
            <a key={'offer_' + offer.id} href="javascript:void(0)" className="select-package pointer" id={'offer_' + offer.id} onClick={this.onOfferClick.bind(this, _get(offer, 'package.id'), _get(offer, 'id'))}>
              {!!offer.picture && <img className="radius" src={offer.picture} />}
              <span className="offer-text-top subscription">{_get(offer, 'package.title')}</span>
              <span className="offer-text-bottom">
                <strong>{price}</strong>
                <Translate content={`profile.offers.type.${_get(offer, '_typeParsed', '_')}`} />
              </span>
              {trialDiv}
            </a>
          );
        }
      });
  }

  _renderAction() {

    return this.props.message.actions.map((action, index) => {

      return <a key={'action_' + index} className="btn-dark-popup pointer" onClick={this.onAction.bind(this, action.func)}> <Translate content={action.title} /> </a>;
    });
  }

  render() {

    return (<div>
        {this.state.isShown && <a className="mw-close ico ico-close pointer slider-resume" onClick={this.onCrossClick.bind(this)}></a>}
        <DivLoader loading={this.isShowLoader()} />
        <VelocityTransitionGroup
          enter={{animation: this.animationEnter, easing: 'ease-in-out', duration: 250}}
          leave={{animation: this.animationLeave, easing: 'ease-in-out', duration: 150, complete: this.onAnimationComplete.bind(this)}}>
          {this.state.isShown ?
            <div>
              <div className="app-offers">
                <DivLoader loading={this.props.inProgress} />
                <div>
                  <div className="offers-wrapper">
                    {this.isSingleOfferAvailable() && <div>
                      <strong><Translate content="profile.offers.pay_as_you_go" /> {(this.isBundleAvailable()) ? <Translate content="profile.offers.or" /> : ''}</strong>
                      <VelocityTransitionGroup
                        enter={{animation: this.animationSingleEnter, delay: 150, duration: 350}}
                        leave={{animation: this.animationSingleLeave, delay: 150, duration: 350}}
                        runOnMount={true}>
                        {this._renderSingleOffer()}
                      </VelocityTransitionGroup>
                    </div>}
                    {this.isBundleAvailable() && <div>
                      <strong><Translate content="profile.offers.select_bundle" /></strong>
                      <VelocityTransitionGroup
                        enter={{animation: this.animationBundleEnter, delay: 150, duration: 200}}
                        leave={{animation: this.animationBundleLeave, delay: 150, duration: 200}}
                        runOnMount={true}>
                        {this._renderBundleOffer()}
                      </VelocityTransitionGroup>
                    </div>}
                  </div>
                </div>
                <strong className="mt- color-blue">{this.props.payment.state === 'error' && this.props.payment.message}</strong>

                <div className="mt+ message-actions offer-action">
                  {this.props.message.actions && this.props.message.actions.length && this._renderAction()}
                </div>
              </div>
            </div> : undefined }
        </VelocityTransitionGroup>
      </div>
    );
  }
}

OffersMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    asset_id: PropTypes.number.isRequired,
    offers: PropTypes.array
  }),
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

const mapStateToProps = ({collections, assets, purchases}, ownProps) => {
  let asset = _get(assets, _get(ownProps, 'message.asset_id', null), {});
  let packages = _at(assets, collections.packages.collection || []);
  let payment = _get(purchases, 'payment.' + _get(ownProps, 'message.asset_id', null), {});

  return {
    asset: asset,
    payment: payment,
    inProgress: _get(assets, ownProps.message.asset_id + '.fetchInProgress', false),
    packages: packages
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetById, InitiatePurchase, StripeProcess, AcknowledgePurchase, ClearPayment}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(OffersMessage);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/Offers/offers-message.js